import { Arg, INPUT_FORM_ARGS, Metadata, pick } from '../../../../utils/spds/metadata';
import { on } from '@ember/modifier';
import FlexRow from '../../layout/flex/row.gjs';
import Super from '../../core/label.gjs';

const METADATA = Metadata.define({
  description: 'Label for search input components',
  extends: [pick(INPUT_FORM_ARGS, ['label'])],
  meta: {
    for: Arg.string({ description: 'ID of the input element this label is associated with' }),
  },
  name: 'Search Label',
});

export default class SpdsInputSearchLabel extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-input-search-label';

  <template>
    <FlexRow
      @content={{@label}}
      @tag="label"
      class={{this.classes}}
      data-test-spds-input-search-label
      id={{this.id}}
      for={{@for}}
      {{on "click" this.handleClick}}
      {{this.validateArguments}}
      ...attributes
    >
      {{yield}}
    </FlexRow>
  </template>
}

export const SEARCH_LABEL_METADATA = SpdsInputSearchLabel.metadata;
